import { log as logger } from './utils';

const log = (...args) => logger('insider', ...args);

const isDebuggerActive = !!process.env.NEXT_PUBLIC_INSIDER_DEBUG;

export const sendInsiderEvent = (name, params = {}) => {
  if (isDebuggerActive) {
    log(`Event '${name}' sent with the following params:\n`, params);
  }

  if (!window.Insider) {
    return;
  }

  /**
   * For predefined event parameters, see:
   * https://academy.useinsider.com/docs/web-event-integration
   */
  window.Insider?.track('events', [
    {
      event_name: name,
      event_params: params,
    },
  ]);
};

export const sendInsiderPageViewEvent = (type, value = {}) => {
  if (isDebuggerActive) {
    let message = `Page view event of type '${type}' sent.`;

    if (value) {
      message = `${message} With the following value:`;
    }

    log(`${message}\n`, value);
  }

  if (!window.InsiderQueue || !window.Insider) {
    return;
  }

  window.InsiderQueue = window.InsiderQueue || [];

  window.InsiderQueue?.push({ type, value });
  window.InsiderQueue?.push({ type: 'init' });
};
